/**
 * Created by Administrador on 16/05/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('revenuePlanningConnectionCtrl', revenuePlanningConnectionCtrl);

    revenuePlanningConnectionCtrl.$inject = ['linkService','tabRevenue','categories','itineraryConnections','itineraryConnectionService'];

    function revenuePlanningConnectionCtrl(linkService,tabRevenue,categories,itineraryConnections,
                                           itineraryConnectionService){
        var vm = this;
        vm.linkService = linkService;
        vm.tabs = tabRevenue;
        vm.categories = categories;
        //vm.itineraryConnections = itineraryConnections;
        vm.itineraryConnections = (itineraryConnections.data._embedded) ? itineraryConnections.data._embedded.connectionsItinerary : [];
        vm.pages = itineraryConnections.data.page;
        vm.editIndexX = -1;

        for(var i=0; i<vm.itineraryConnections.length; i++){
            vm.itineraryConnections[i].segmentClasses = [];
            vm.itineraryConnections[i].disabledClass = true;
            vm.itineraryConnections[i].disabledEdit = false;
            vm.itineraryConnections[i].showEdit = true;
            vm.itineraryConnections[i].showSave = false;
            for(var c=0; c<categories.length; c++){
                for(var cl=0; cl<categories[c]._embedded.fareClasses.length; cl++){
                    var classId = linkService.getLinkId(categories[c]._embedded.fareClasses[cl]._links.self.href);
                    var indexClass = getIndexClass(classId,vm.itineraryConnections[i]._embedded.segmentClassItis);
                    vm.itineraryConnections[i].segmentClasses.push(
                        {
                            "id": vm.linkService.getLinkId(vm.itineraryConnections[i]._embedded.segmentClassItis[indexClass]._links.self.href),
                            "classId": classId,
                            "value": vm.itineraryConnections[i]._embedded.segmentClassItis[indexClass].value
                        }
                    );
                }
            }
        }

        vm.editSegmentItineraryClass = function(indexX){
            if(vm.editIndexX == indexX || vm.editIndexX == -1){
                vm.itineraryConnections[indexX].disabledClass = false;
                vm.itineraryConnections[indexX].showEdit = false;
                vm.editIndexX = indexX;
                vm.auxSegments = angular.copy(vm.itineraryConnections[indexX].segmentClasses);
            }
        }

        vm.cancelSegmentItineraryClass = function(indexX){
            vm.itineraryConnections[indexX].segmentClasses = angular.copy(vm.auxSegments);
            vm.itineraryConnections[indexX].disabledClass = true;
            vm.itineraryConnections[indexX].showEdit = true;
            vm.editIndexX = -1;
            vm.auxSegments = [];
        }

        vm.saveSegmentItinerary = function(valid,indexX){
            if(valid){
                var saveSegmentClassConnectionIti = {
                    "id": vm.linkService.getLinkId(vm.itineraryConnections[indexX]._links.self.href),
                    "capacities": vm.itineraryConnections[indexX].segmentClasses
                };

                itineraryConnectionService.updateSegmentClassItineraries(saveSegmentClassConnectionIti)
                    .then(function(res){
                        if(res != "ok"){
                            vm.itineraryConnections[indexX].segmentClasses = angular.copy(vm.auxSegments);
                        }
                        vm.itineraryConnections[indexX].disabledClass = true;
                        vm.itineraryConnections[indexX].showEdit = true;
                        vm.editIndexX = -1;
                        vm.auxSegments = [];
                    });

            }
        }
    }

    function getIndexClass(classId,segmentClassItis){
        var res = 0;
        if(segmentClassItis != undefined) {
            for (var i = 0; i < segmentClassItis.length; i++) {
                if (segmentClassItis[i].classId == classId) {
                    res = i;
                    break;
                }
            }
        }
        return res;
    }
})();
